import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 退園日時
 */
export class RemoveDateTime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): RemoveDateTime {
    return new RemoveDateTime(value);
  }

  /** ラベル */
  static get label(): string {
    return '退園処理日時';
  }

  /** プレースホルダー */
  static get placeholder(): Date {
    return new Date('2022-01-01');
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
